export const LOGIN_RETURN_URL_KEY = "AIHUB_LOGIN_RETURN_URL";
